import * as React from 'react';
import DefaultLayout from '../../../../components/DefaultLayout';
import Section from '@hero/ui-kit/layout/Section';
import InlineLoader from '../../../../components/InlineLoader';
import P from '@hero/ui-kit/typography/P';
import H from '@hero/ui-kit/typography/H';
import { useNavigate } from 'react-router-dom';
import * as Style from './style.module.css';
import useGetUnreadSmsList from '../../api/useGetUnreadSmsList';
import { UnreadSmsListResponse } from '../../types';
import Button from '@hero/ui-kit/inputs/Button';
import { Link } from 'react-router-dom';

const CRMUnreadSmsListInner: React.FC<{ smsList: UnreadSmsListResponse[] }> = ({ smsList }) => {
    const navigate = useNavigate();

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleString();
    };

    const handleBackToList = () => {
        navigate('/crm/list');
    };

    const headerWrapStyles: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    };

    return (
        <DefaultLayout>
            <Section>
                <div style={headerWrapStyles}>
                    <H role="h4" styles={{ marginBottom: '20px' }}>
                        Unread SMS Messages
                    </H>
                    <Button variant="secondary" onClick={handleBackToList} noDefaultMargin>
                        Back To List
                    </Button>
                </div>
                {smsList.length > 0 ? (
                    <div className={Style.tableContainer}>
                        <div className={Style.listHeader} role="row">
                            <div>Phone</div>
                            <div>Message</div>
                            <div>Received At</div>
                            <div>Status</div>
                        </div>
                        <div className={Style.listBody}>
                            {smsList.map((sms, index) => (
                                <Link
                                    to={`/crm/${sms.prospect_id}/details?force_sms_log=true`}
                                    key={`${sms.prospect_id}-${index}`}
                                    className={Style.listRow}
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <div className={Style.phoneCell}>{sms.phone}</div>
                                    <div className={Style.messageCell}>
                                        <div className={Style.messageContent}>{sms.message}</div>
                                    </div>
                                    <div className={Style.dateCell}>
                                        {formatDate(sms.created_at)}
                                    </div>
                                    <div
                                        className={Style.agentCell}
                                    >{`${sms.inbound ? 'Received' : 'Sent'}`}</div>
                                </Link>
                            ))}
                        </div>
                    </div>
                ) : (
                    <P>No unread SMS found.</P>
                )}
            </Section>
        </DefaultLayout>
    );
};

const CRMUnreadSmsList: React.FC = () => {
    const { data, isFetching } = useGetUnreadSmsList();

    return isFetching ? (
        <DefaultLayout>
            <InlineLoader />
        </DefaultLayout>
    ) : (
        <CRMUnreadSmsListInner smsList={data?.data || []} />
    );
};

export default CRMUnreadSmsList;
